var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.level === 1)?_c('h1',{class:_vm.computedClass},[_vm._v(_vm._s(_vm.title))]):(_vm.level === 2)?_c('h2',{class:_vm.computedClass},[_vm._v(_vm._s(_vm.title))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }